<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.4264 15.0322C24.1912 15.4461 24.1912 16.5539 23.4264 16.9678L11.5999 23.3684C10.876 23.7602 10 23.2303 10 22.4006L10 9.59942C10 8.7697 10.876 8.23983 11.5999 8.63165L23.4264 15.0322Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
